
import Cookies from 'js-cookie';
import md5 from 'crypto-js/md5';

const UserTokenKey = 'desk-User-Token';

export function getUserToken(){

  let temp = Cookies.get(UserTokenKey);
  if (!temp || temp === 'undefined') {
    temp = false;
  }
  return temp;
}

export function setUserToken(token){
  return Cookies.set(UserTokenKey, token);
}

export function removeUserToken(){
  return Cookies.remove(UserTokenKey);
}


export const authMethod = {
  sign: function(args, key){
    let keys = Object.keys(args);
    keys = keys.sort();
    const newArgs = {};
    keys.forEach(function(key){
      newArgs[key] = args[key];
    });
    let string = '';
    for (const k in newArgs) {
      if (k !== 'sign') {
		  string += '&' + k + '=' + newArgs[k];
      }
    }
    string = string.substr(1) + '&key=' + key;
    return md5(string);
  },
  // 随机字符串产生函数
  createNonceStr: function(){
    return Math.random().toString(36).substr(2, 15);
  },

  // 时间戳产生函数
  createTimeStamp: function(){
    return parseInt(new Date().getTime() / 1000) + '';
  },
  genAllParam(appId, appKey, userToken, paramsString){
    const data = {
      appid: appId,
      timestamp: this.createTimeStamp(),
      noncestr: this.createNonceStr()
    };
    if (userToken) {
      data.usertoken = userToken;
    }
    if (paramsString) {
      data.params = paramsString;
    }
    data.sign = this.sign(data, appKey);
    return data;
  }
};




// WEBPACK FOOTER //
// ./src/utils/auth.js